<div class="step-container">
  <div *ngIf="optOutAlerts$ | async; else failed">
    <h1 class="text-black">{{ 'registration.opt.out.alerts.title' | translate }}</h1>
    <fgbcl-errors></fgbcl-errors>
    <div class="alert-container" *ngFor="let optOutAlert of optOutAlerts">
      <div class="mb-2">
        <p
          class="form-check-label font-size-14"
          [for]="optOutAlert.AlertId"
          [innerHTML]="'registration.opt.out.alerts.description' | translate | markdownTranslate | safeHtml"
        ></p>
        <div class="d-flex align-items-center mt-2">
          <div class="checkbox-alert mt-2 mt-lg-3">
            <div class="accept-box">
              <input
                class="form-check-input ms-1"
                type="checkbox"
                [(ngModel)]="optOutAlert.Value"
                [id]="optOutAlert.AlertId"
                required
              />
              <label for="accepted" class="d-inline-block font-size-12 ps-1 fw-bold ms-1">{{
                'registration.opt.out.alerts.checkbox.text' | translate
              }}</label>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
  </div>
  <ng-template #failed> </ng-template>
</div>
